import { GitBranchIcon } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import {
	Collapsible,
	CollapsibleContent,
	CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { ScrollArea } from "@/components/ui/scroll-area";
import { MessageTimeline } from "./MessageTimeline";
import type { ThreadChild } from "./types";

function formatJson(value: unknown): string {
	if (value == null) return "";
	if (typeof value === "string") return value;
	return JSON.stringify(value, null, 2);
}

export function ChildThreadInline({
	childThread,
	result,
}: {
	childThread: ThreadChild;
	result?: unknown;
}) {
	return (
		<Collapsible
			defaultOpen
			className="rounded-lg border-l-2 border-primary/30 pl-3"
		>
			<CollapsibleTrigger className="flex w-full cursor-pointer items-center gap-2 py-2 text-sm">
				<GitBranchIcon className="size-3.5 text-primary/60" />
				<span className="font-medium">Sub-thread</span>
				{childThread.kind && (
					<Badge variant="outline" className="text-xs">
						{childThread.kind}
					</Badge>
				)}
				<span className="font-mono text-xs text-muted-foreground">
					{childThread.clericalThreadId}
				</span>
			</CollapsibleTrigger>
			<CollapsibleContent>
				<div className="pb-2">
					<MessageTimeline
						clericalThreadId={childThread.clericalThreadId}
						childThreads={new Map()}
					/>
				</div>
				{result !== undefined && (
					<Collapsible className="mb-2">
						<CollapsibleTrigger className="cursor-pointer text-xs text-muted-foreground hover:text-foreground">
							Tool result
						</CollapsibleTrigger>
						<CollapsibleContent>
							<ScrollArea
								orientation="horizontal"
								className="mt-1 rounded-md bg-muted"
							>
								<pre className="p-2 text-xs">{formatJson(result)}</pre>
							</ScrollArea>
						</CollapsibleContent>
					</Collapsible>
				)}
			</CollapsibleContent>
		</Collapsible>
	);
}
